module.exports = __webpack_public_path__ + "static/media/Evraz_ru.d92e6acd.svg";